import styled from 'styled-components'

export const Container = styled.article`
	min-height: 74vh;
	display: flex;
	flex-direction: column;
	justify-content: center;
	padding: 10px 4rem 40px 4rem;
	gap: 3rem;

	@media(max-width: 1024px) {
		padding: 10px 4rem 40px 4rem;
	}

	@media(max-width: 600px) {
		padding: 10px 4rem 40px 4rem;
	}

	@media(max-width: 440px) {
		padding: 10px 1rem 40px 1rem;
	}

	img {
		width: 100%;
		max-width: 200px;
		margin-bottom: 10px;
		margin-top: 15px;
	}

	h1 {
		font-size: 18px;
		font-weight: 500;
	}

	h2 {
		font-size: 22px;
		font-weight: 500;
	}
`
